import React from 'react';
import { Helmet } from 'react-helmet-async';

function Privacy() {
  return (
    <div style={{ maxWidth: '900px', margin: '0 auto', padding: '60px 20px' }}>
      <Helmet>
        <title>Privacy Policy | Giovanni Rampazzo</title>
        <meta name="description" content="Informativa sulla privacy e trattamento dei dati personali" />
      </Helmet>

      <h1 style={{ marginBottom: '20px' }}>Privacy Policy</h1>
      <p style={{ color: 'var(--text-sub)', marginBottom: '40px' }}>
        Ultimo aggiornamento: {new Date().toLocaleDateString('it-IT')}
      </p>

      <section style={{ marginBottom: '40px' }}>
        <h2 style={{ fontSize: '1.8rem', marginBottom: '15px' }}>1. Titolare del Trattamento</h2>
        <p style={{ color: 'var(--text-sub)', lineHeight: '1.8' }}>
          Il Titolare del trattamento dei dati personali è:<br /><br />
          <strong>Giovanni Rampazzo</strong><br />
          P.IVA: 05625510283<br />
          Email: <a href="mailto:info@giovannirampazzo.com" style={{ color: 'var(--accent)' }}>info@giovannirampazzo.com</a>
        </p>
      </section>

      <section style={{ marginBottom: '40px' }}>
        <h2 style={{ fontSize: '1.8rem', marginBottom: '15px' }}>2. Tipologie di Dati Raccolti</h2>
        <p style={{ color: 'var(--text-sub)', lineHeight: '1.8', marginBottom: '15px' }}>
          I dati personali raccolti tramite questo sito web includono:
        </p>
        <ul style={{ color: 'var(--text-sub)', lineHeight: '2', paddingLeft: '20px' }}>
          <li><strong>Dati di contatto:</strong> nome, email</li>
          <li><strong>Dati forniti volontariamente:</strong> servizio richiesto, messaggio/dettagli progetto</li>
          <li><strong>Dati di navigazione:</strong> indirizzo IP, tipo di browser, pagine visitate, durata della visita</li>
          <li><strong>Cookie tecnici e di terze parti:</strong> per il funzionamento del sito e l'analisi del traffico</li>
        </ul>
      </section>

      <section style={{ marginBottom: '40px' }}>
        <h2 style={{ fontSize: '1.8rem', marginBottom: '15px' }}>3. Finalità del Trattamento</h2>
        <p style={{ color: 'var(--text-sub)', lineHeight: '1.8', marginBottom: '15px' }}>
          I dati personali vengono trattati per le seguenti finalità:
        </p>
        <ul style={{ color: 'var(--text-sub)', lineHeight: '2', paddingLeft: '20px' }}>
          <li><strong>Gestione richieste di contatto:</strong> rispondere alle richieste di preventivo e consulenza</li>
          <li><strong>Comunicazioni commerciali:</strong> invio di informazioni sui servizi offerti (solo con consenso)</li>
          <li><strong>Analisi e statistiche:</strong> miglioramento dell'esperienza utente e delle performance del sito</li>
          <li><strong>Sicurezza:</strong> protezione da spam e bot tramite reCAPTCHA</li>
        </ul>
      </section>

      <section style={{ marginBottom: '40px' }}>
        <h2 style={{ fontSize: '1.8rem', marginBottom: '15px' }}>4. Base Giuridica del Trattamento</h2>
        <p style={{ color: 'var(--text-sub)', lineHeight: '1.8' }}>
          Il trattamento dei dati personali si basa su:<br /><br />
          <strong>Consenso dell'interessato</strong> (art. 6, comma 1, lett. a) GDPR) per l'invio di comunicazioni commerciali<br />
          <strong>Esecuzione di misure precontrattuali</strong> (art. 6, comma 1, lett. b) GDPR) per rispondere alle richieste di preventivo<br />
          <strong>Legittimo interesse del titolare</strong> (art. 6, comma 1, lett. f) GDPR) per analisi statistiche e sicurezza
        </p>
      </section>

      <section style={{ marginBottom: '40px' }}>
        <h2 style={{ fontSize: '1.8rem', marginBottom: '15px' }}>5. Modalità del Trattamento</h2>
        <p style={{ color: 'var(--text-sub)', lineHeight: '1.8' }}>
          I dati personali sono trattati con strumenti elettronici e conservati su server sicuri.
          Il Titolare adotta misure di sicurezza tecniche e organizzative adeguate per proteggere i dati
          da accessi non autorizzati, perdita o distruzione.
        </p>
      </section>

      <section style={{ marginBottom: '40px' }}>
        <h2 style={{ fontSize: '1.8rem', marginBottom: '15px' }}>6. Periodo di Conservazione</h2>
        <p style={{ color: 'var(--text-sub)', lineHeight: '1.8' }}>
          I dati personali verranno conservati per il tempo strettamente necessario alle finalità per cui sono stati raccolti:
        </p>
        <ul style={{ color: 'var(--text-sub)', lineHeight: '2', paddingLeft: '20px' }}>
          <li>Richieste di preventivo: 2 anni dalla ricezione</li>
          <li>Cookie tecnici: durata della sessione di navigazione</li>
          <li>Cookie analytics: massimo 24 mesi</li>
        </ul>
      </section>

      <section style={{ marginBottom: '40px' }}>
        <h2 style={{ fontSize: '1.8rem', marginBottom: '15px' }}>7. Comunicazione e Diffusione dei Dati</h2>
        <p style={{ color: 'var(--text-sub)', lineHeight: '1.8' }}>
          I dati personali non vengono diffusi a terzi. Possono essere comunicati a:<br /><br />
          <strong>Fornitori di servizi tecnici:</strong> hosting (Aruba S.p.A.), servizi email<br />
          <strong>Google LLC:</strong> per il servizio reCAPTCHA Enterprise (protezione anti-spam)
        </p>
      </section>

      <section style={{ marginBottom: '40px' }}>
        <h2 style={{ fontSize: '1.8rem', marginBottom: '15px' }}>8. Diritti dell'Interessato</h2>
        <p style={{ color: 'var(--text-sub)', lineHeight: '1.8', marginBottom: '15px' }}>
          In qualità di interessato, hai diritto a:
        </p>
        <ul style={{ color: 'var(--text-sub)', lineHeight: '2', paddingLeft: '20px' }}>
          <li><strong>Accesso:</strong> ottenere conferma dell'esistenza dei tuoi dati e riceverne copia</li>
          <li><strong>Rettifica:</strong> correggere dati inesatti o incompleti</li>
          <li><strong>Cancellazione:</strong> richiedere la cancellazione dei dati (diritto all'oblio)</li>
          <li><strong>Limitazione:</strong> limitare il trattamento in determinati casi</li>
          <li><strong>Portabilità:</strong> ricevere i dati in formato strutturato e leggibile</li>
          <li><strong>Opposizione:</strong> opporti al trattamento per legittimo interesse</li>
          <li><strong>Revoca del consenso:</strong> revocare in qualsiasi momento il consenso prestato</li>
        </ul>
        <p style={{ color: 'var(--text-sub)', lineHeight: '1.8', marginTop: '15px' }}>
          Per esercitare i tuoi diritti, contatta: <a href="mailto:info@giovannirampazzo.com" style={{ color: 'var(--accent)' }}>info@giovannirampazzo.com</a>
        </p>
      </section>

      <section style={{ marginBottom: '40px' }}>
        <h2 style={{ fontSize: '1.8rem', marginBottom: '15px' }}>9. reCAPTCHA Enterprise</h2>
        <p style={{ color: 'var(--text-sub)', lineHeight: '1.8' }}>
          Questo sito utilizza reCAPTCHA Enterprise di Google per proteggere i moduli da spam e bot.
          L'uso di reCAPTCHA è soggetto alla{' '}
          <a href="https://policies.google.com/privacy" target="_blank" rel="noopener noreferrer" style={{ color: 'var(--accent)' }}>
            Privacy Policy
          </a>
          {' '}e ai{' '}
          <a href="https://policies.google.com/terms" target="_blank" rel="noopener noreferrer" style={{ color: 'var(--accent)' }}>
            Termini di Servizio
          </a>
          {' '}di Google.
        </p>
      </section>

      <section style={{ marginBottom: '40px' }}>
        <h2 style={{ fontSize: '1.8rem', marginBottom: '15px' }}>10. Modifiche alla Privacy Policy</h2>
        <p style={{ color: 'var(--text-sub)', lineHeight: '1.8' }}>
          Il Titolare si riserva il diritto di modificare questa Privacy Policy in qualsiasi momento.
          Le modifiche saranno pubblicate su questa pagina con indicazione della data di ultimo aggiornamento.
        </p>
      </section>

      <section style={{ marginBottom: '40px' }}>
        <h2 style={{ fontSize: '1.8rem', marginBottom: '15px' }}>11. Reclami</h2>
        <p style={{ color: 'var(--text-sub)', lineHeight: '1.8' }}>
          Hai il diritto di proporre reclamo all'Autorità Garante per la Protezione dei Dati Personali:<br /><br />
          <strong>Garante per la protezione dei dati personali</strong><br />
          Piazza Venezia, 11 - 00187 Roma<br />
          Tel: +39 06.696771<br />
          Email: garante@gpdp.it<br />
          Sito web: <a href="https://www.garanteprivacy.it" target="_blank" rel="noopener noreferrer" style={{ color: 'var(--accent)' }}>www.garanteprivacy.it</a>
        </p>
      </section>
    </div>
  );
}

export default Privacy;
